import script from "./RecoveryPasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecoveryPasswordPage.vue?vue&type=script&setup=true&lang=ts"

import "./RecoveryPasswordPage.vue?vue&type=style&index=0&id=0e0de11a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0de11a"]])

export default __exports__